import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class ServiceInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    try {
      if(new URL(request.url).hostname.includes('ca-rool.com'))
        return next.handle(request.clone({ headers: request.headers.set('X-Service-Name', 'WebApp') }));
    } catch (_) {}
    return next.handle(request);
  }
}
